import React from 'react';
import { MainGridRow } from './MainGridRow';

export const MainGrid = ({ headers, rows, onOpenModal }) => {
  const totalColumns = headers.reduce((count, header) => {
    return count + (header.subheaders ? header.subheaders.length : 1);
  }, 0);

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${totalColumns}, 1fr)`,
    backgroundColor: '#fff',
  };

  return (
    <div style={gridStyle}>
      {/* Headers */}
      {headers.map((header, index) => {
        if (typeof header === 'string') {
          const isDetailsHeader = header === 'Details';
          const style = { gridRow: '1 / 3' };
          if (isDetailsHeader) {
            style.gridColumn = `${totalColumns}`;
          }
          return (
            <div key={index} className="grid-header-main single" style={style}>
              {header}
            </div>
          );
        } else {
          return (
            <React.Fragment key={index}>
              <div className="grid-header-main split-main-title" style={{ gridColumn: `span ${header.subheaders.length}` }}>
                {header.title}
              </div>
              {header.subheaders.map((subheader, subIndex) => (
                <div key={subIndex} className="grid-header-main split-subheader">
                  {subheader}
                </div>
              ))}
            </React.Fragment>
          );
        }
      })}
        
      {/* The row rendering logic does NOT need to change! */}
      {rows.map((row, index) => (
        <MainGridRow 
          key={row.id} 
          row={row} 
          rowIndex={index} 
          onOpenModal={onOpenModal} 
          totalColumns={totalColumns}
        />
      ))}
    </div>
  );
};